// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setMasterData } from "_core/slices/datas/MasterSlice";
import { setApiTimestamp, setTransactionData, mergeTransactionData } from "_core/slices/datas/TransactionSlice";


const AdminUpdateRAGApi = () => {
    const dispatch = useDispatch();

    // API固有の設定、URLとリクエスト
    const url = "/admin/update_rag";

    // API実行, asset_type, file ,file_name
    const ExecAdminUpdateRAGApi = async (t_asset_id, operation, use_fixed_chunk) => {

        // 必要なリクエストを定義
        const requestParams = {
            t_asset_id: t_asset_id,
            operation: operation,
            use_fixed_chunk: use_fixed_chunk
        };
    
        let response = null;
        let error = null;
    
        // console.log(url + "API開始");
        try {
            response = await ApiRequest({ url:url, requestParams:requestParams, timeout:60*60*1000 });
            // console.log(response);
        } catch (e) {
            // console.log(e);
            error = e;
        } finally {
            // console.log(url + "　API終了");
        }

        // レスポンスがあれば、データ更新
        if (response !== null && response.error_code === 0) {
            dispatch(setApiTimestamp(response['now_time']));

            if(response['t_asset_list'] !=null)
            {
                dispatch(mergeTransactionData({
                    tAssetList:response['t_asset_list'],
                }));
            }
        }
        return { response, error };
    };

    return ExecAdminUpdateRAGApi;
};

export default AdminUpdateRAGApi;